<template>
    <div class="about">
        <p>{{this.messages}}</p>
    </div>
</template>

<script>
    export default({
        props:{
            "messages":{}
        }
    })
</script>

<style scoped>
    .about{
        margin-top: 20px;
        padding-left: 10%;
    }
    .about p {
        font-size: 13px;
        font-weight: bold;
    }

</style>